import { PricingModelTab } from '@received/pricing-model';
import { Tabs } from '../../../../../components';
import { CreditNoteContent } from '../../../../../components/PricingModelTabContent';
import { Payout } from '../../../../../types/PayoutsTypes';
import styles from './PayoutProducts.module.scss';

interface PayoutProductsProps {
	payout: Payout;
	isEditMode: boolean;
	selectedProductTab: number;
	setSelectedProductTab: (tab: number) => void;
	onUpdateManualReportFromTable: () => void;
	onUpdateCreditNotePricingModel: (data: PricingModelTab) => void;
}

export const PayoutProducts = ({
	payout,
	isEditMode,
	selectedProductTab,
	setSelectedProductTab,
	onUpdateCreditNotePricingModel,
	onUpdateManualReportFromTable,
}: PayoutProductsProps) => {
	return (
		<div>
			<Tabs
				id='pricing-model-tab-button'
				tabsArray={payout?.pricingModel.tabs.map((tab) => ({ label: tab.name, labelTitle: tab.productName, value: tab.name }))}
				classNames={styles}
				updateChosenTab={setSelectedProductTab}
				chosenTab={selectedProductTab}
			/>
			<CreditNoteContent
				selectedCustomer={payout?.customer}
				pricingModelTab={payout.pricingModel.tabs[selectedProductTab]}
				updatePricingModelData={(data) => onUpdateCreditNotePricingModel(data)}
				onUpdateManualReportFromTable={onUpdateManualReportFromTable}
				className={styles.tabsContent}
				isEditable={isEditMode}
			/>
		</div>
	);
};
